import React, { FC, useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { FaEdit } from 'react-icons/fa';

interface User {
  id: string;
  first_name: string;
  last_name: string;
}

interface UserTableProps {
  users: User[];
  handleEdit: (id: string) => void;
}

interface WindowSize {
  width: number | undefined;
  height: number | undefined;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const UserTable: FC<UserTableProps> = ({ users, handleEdit }) => {
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const breakpoint = 576;

  return (
    <Table
      bordered
      hover
      responsive
      className="text-center"
    >
      <colgroup>
        <col style={{ width: '50%' }} />
        <col style={{ width: '50%' }} />
      </colgroup>
      <thead>
        <tr>
          <th>{t('table.userFilter')}</th>
          <th>{t('table.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {users.map(user => (
          <tr key={user.id}>
            <td>
              {user.first_name} {user.last_name}
            </td>
            <td>
              <Button onClick={() => handleEdit(user.id)}>
                <FaEdit className="mr-2" />
                {width && width > breakpoint ? t('docWizard.step4.description') : t('docWizard.step4.descriptionShort')}
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default UserTable;
